export default __webpack_public_path__ + "static/media/btn_big_purchasecad.86c08dee.svg";